import React, { FC } from "react";
import {
  Typography,
  Button,
  Modal,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { StyledModalDiv } from "../../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import usePoSelector from "./usePoSelector";
import EditIcon from "@mui/icons-material/Edit";

const StyledDivCol = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  padding: 20,
});

interface PoModalProps {
  open: boolean;
  handleClose: () => void;
  handlePoChangeModal: (e: React.ChangeEvent<HTMLInputElement>) => void;
  po: string;
  handleEditPoClick: () => void;
  editPoClicked: boolean;
  handleUpdatePoClick: (input: string) => Promise<void>;
  isUpdatingPo: boolean;
  status: string;
}

const StyledEditIcon = styled(IconButton)({
  width: 17,
  height: 17,
});

const StyledEditButton = styled(Button)(({ theme }) => ({
  width: 75,
  height: 24,
  color: "white",
}));

const Loader: FC = () => {
  return (
    <div style={{ width: 18, height: 18, marginLeft: 10 }}>
      <CircularProgress size={18} color="primary" />
    </div>
  );
};

const PoModal: FC<PoModalProps> = ({
  open,
  handleClose,
  handlePoChangeModal,
  po,
  handleEditPoClick,
  editPoClicked,
  handleUpdatePoClick,
  isUpdatingPo,
  status,
}) => {
  const { modalStyle } = usePoSelector();

  const body = (
    <StyledModalDiv style={modalStyle}>
      <StyledDivCol>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: 20,
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>PO #:</Typography>
          <input
            maxLength={20}
            style={{ width: 150, marginLeft: 10 }}
            value={po}
            onChange={(e) => handlePoChangeModal(e)}
            name="po"
            type="text"
            placeholder="PO #"
            disabled={status !== "Quote" && (!editPoClicked || isUpdatingPo)}
          />
          {status !== "Quote" &&
            (!editPoClicked ? (
              <StyledEditIcon
                size="small"
                style={{ marginLeft: 10 }}
                onClick={handleEditPoClick}
              >
                <EditIcon color="primary" />
              </StyledEditIcon>
            ) : !isUpdatingPo ? (
              <StyledEditButton
                variant="contained"
                color="primary"
                size="small"
                style={{ marginLeft: 10 }}
                onClick={() => handleUpdatePoClick(po)}
                // disabled={btnDisabled}
              >
                Confirm
              </StyledEditButton>
            ) : (
              <Loader />
            ))}
        </div>
      </StyledDivCol>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{ backgroundColor: "grey.500", "&:hover": { backgroundColor: "grey.600" } }}
        >
          Close
        </Button>
      </div>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default PoModal;
